import { call, put, takeLatest } from 'redux-saga/effects';
import settingService from '../../../services/settingService';
import {
  fetchSettings,
  fetchSettingsSuccess,
  fetchSettingsFailure,
  updateSettings,
  updateSettingsSuccess,
  updateSettingsFailure,
} from './slice';

function* handleFetchSettings() {
  try {
    const response = yield call(settingService.getSettings);
    yield put(fetchSettingsSuccess(response));
  } catch (error) {
    yield put(fetchSettingsFailure(error.message));
  }
}

function* handleUpdateSettings(action) {
  try {
    const response = yield call(settingService.updateSettings, action.payload);
    yield put(updateSettingsSuccess(response));
    // Refetch settings after successful update
    yield put(fetchSettings());
  } catch (error) {
    // Extract detailed error message from response
    let errorMessage = error.message || 'Có lỗi xảy ra khi cập nhật cài đặt';
    
    if (error.response && error.response.data) {
      const errorData = error.response.data;
      
      // Handle validation errors from backend
      if (errorData.errors && typeof errorData.errors === 'object') {
        // Format validation errors: "Field X invalid: message"
        const errorMessages = Object.entries(errorData.errors)
          .map(([field, messages]) => {
            const fieldName = field.charAt(0).toUpperCase() + field.slice(1);
            const message = Array.isArray(messages) ? messages.join(', ') : messages;
            return `${fieldName}: ${message}`;
          });
        errorMessage = errorMessages.join('; ') || errorMessage;
      } else if (errorData.message) {
        errorMessage = errorData.message;
      } else if (typeof errorData === 'string') {
        errorMessage = errorData;
      }
    }
    
    yield put(updateSettingsFailure(errorMessage));
  }
}

export function* watchSettingsActions() {
  yield takeLatest(fetchSettings.type, handleFetchSettings);
  yield takeLatest(updateSettings.type, handleUpdateSettings);
}
